import { DisciplineEvaluationAndDeadlines } from '@/models/evaluation-and-deadlines/evaluation-and-deadlines.model';
import { ActiveStudyWindow } from '@/services/undergrad/pegasus-pepe-legal/user-grades.service';

export interface AssessmentState {
  activeStudyWindows?: ActiveStudyWindow[];
  evaluationAndDeadlines?: DisciplineEvaluationAndDeadlines[];
}

const state: AssessmentState = {
  activeStudyWindows: undefined,
  evaluationAndDeadlines: undefined,
};

export default state;
